module.exports = __webpack_public_path__ + "officialStatic/fonts/PingFangSCLight.2593fa3.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/woff2/PingFangSCLight.woff2
// module id = oB5/
// module chunks = 0